// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as AllocationCampaignDetailModal from "./AllocationCampaignDetailModal.bs.js";

function getModalComponent(modalState, toggleModal) {
  var close_modal = function (param) {
    return Curry._1(toggleModal, (function (param) {
                  
                }));
  };
  if (modalState !== undefined) {
    return React.createElement(AllocationCampaignDetailModal.make, {
                mandatory_campaign: modalState.mandatory_campaign,
                selected_geo_region: modalState.selected_geo_region,
                selected_vehicle: modalState.selected_vehicle,
                modification: modalState.modification,
                zones: modalState.zones,
                clusters: modalState.clusters,
                close_modal: close_modal
              });
  } else {
    return null;
  }
}

function useModal(param) {
  var match = React.useState(function () {
        
      });
  var toggleModal = match[1];
  var modal_component = getModalComponent(match[0], toggleModal);
  var open_modal = function (modal) {
    return Curry._1(toggleModal, (function (param) {
                  return modal;
                }));
  };
  return [
          modal_component,
          open_modal
        ];
}

export {
  getModalComponent ,
  useModal ,
  
}
/* react Not a pure module */
